module.exports = __webpack_public_path__ + "img/alogo.48f5eb88.png";